/**
 * Google Tag Manager Analytics Helper
 */
import Cookies from "js-cookie";

function hasAnalyticsConsent() {
  const hasConsent = Cookies.get("cookie-consent") === "true";
  const analyticsEnabled = Cookies.get("analytics-enabled") === "true";

  return hasConsent && analyticsEnabled;
}

function pushToDataLayer(payload) {
  if (!hasAnalyticsConsent() || !window.dataLayer) {
    return;
  }

  window.dataLayer.push(payload);
}

/**
 * Push a custom event to GTM dataLayer
 * @param {string} event - Event name
 * @param {object} data - Additional event data
 */
export const trackEvent = (event, data = {}) => {
  pushToDataLayer({
    event,
    ...data,
  });
};

/**
 * Track a page view
 * @param {object} route - Vue Router route object
 */
export const trackPageView = (route) => {
  pushToDataLayer({
    event: "pageview",
    page: {
      path: route.path,
      title: route.name || document.title,
      url: window.location.href,
    },
  });
};

/**
 * Track user actions
 * @param {string} action - Action name
 * @param {string} category - Event category
 * @param {string} label - Event label
 * @param {number} value - Event value
 */
export const trackAction = (action, category = '', label = '', value = null) => {
  pushToDataLayer({
    event: "user_action",
    action,
    category,
    label,
    value,
  });
};

/**
 * Track form submissions
 * @param {string} formName - Name of the form
 * @param {boolean} success - Whether submission was successful
 */
export const trackFormSubmission = (formName, success = true) => {
  pushToDataLayer({
    event: "form_submission",
    form_name: formName,
    success,
  });
};

/**
 * Track errors
 * @param {string} errorType - Type of error
 * @param {string} errorMessage - Error message
 * @param {string} location - Where the error occurred
 */
export const trackError = (errorType, errorMessage, location = '') => {
  pushToDataLayer({
    event: "error",
    error_type: errorType,
    error_message: errorMessage,
    error_location: location,
  });
};

